import actionTypes from '../constants/action-types';

const createPageFromTemplate = ({
  pageTemplateId,
  title,
  displayInNavigation = false,
  pageModifier = null,
  displayBusinessName = null,
  skipActivePageChange = false,
  parentFolderId = null,
  resolve = Function.prototype,
  reject = Function.prototype,
}) => ({
  type: actionTypes.CREATE_PAGE_FROM_TEMPLATE,
  payload: {
    pageTemplateId,
    title,
    displayInNavigation,
    pageModifier,
    displayBusinessName,
    skipActivePageChange,
    parentFolderId,
    resolve,
    reject,
  },
});

export default createPageFromTemplate;
